query GetAudienceDashboard($input: DashboardInput!) {
    audienceDashboard(input: $input) {
        audiences {
            audience {
                id
                name
                htmlUrlPath
            }
            formattedTotal
        }
        totalCount
    }
}
